import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import styled from '@mui/material/styles/styled';
import {PrimaryLightInput, PrimaryOutlinedButton} from '../theme/index';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Checkbox from '@mui/material/Checkbox';
import { UseScreen } from '../hooks/UseScreen.hook';
import { loginAction } from '../redux/reducers/Login';
import { useDispatch, useSelector } from 'react-redux';
import DangerModal from '../components/DangerModal';
import { modalDeleteAction } from '../redux/reducers/Modal';
import { useNavigate } from 'react-router-dom';


const GridPrimaryDark = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  fontFamily: 'Roboto-Medium',
  height: '50vh',
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center'
}))

const GridPrimaryLight = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  fontFamily: 'Roboto-Medium',
  height: '50vh'
}))

const CheckboxPrimary = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.primary.main,
  },

  'svg': {
    color: theme.palette.primary.main
  },
}))

const Login = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [success, setSuccess] =  useState(false);
  const [errorAccess, setErrorAccess] =  useState(false);
  const [ showDeleteModal, setShowDeleteModal ] = useState(false);
  const screenWidth = UseScreen();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const loginSuccess = useSelector( state => state.Login.success );
  const loginError = useSelector( state => state.Login.error );
  const deleteModalState = useSelector( state => state.Modal.deleteModalState );

  const handleVisibilityPassword = () => {
    setShowPassword(!showPassword);
  }

  useEffect( () => {
    setSuccess(loginSuccess);
    if( loginSuccess && localStorage.getItem('htuser') ) navigate('/dashboard');
  },[loginSuccess] )

  useEffect( () => {
    setErrorAccess(loginError);
    if( loginError ){
      dispatch(modalDeleteAction());
      dispatch(loginAction(username, password));
    }
  },[loginError] )

  useEffect( () => {
    setShowDeleteModal(deleteModalState);
  },[deleteModalState] )

  const loginAccess = (username, password) => {
    dispatch(loginAction(username, password));
  }

  const imgStyle = () => {
    if( screenWidth <= 500 ){
      return { display: 'none' }
    }else if( screenWidth > 500 && screenWidth < 800 ){
      return { width: '10%' }
    }else{
      return { width: '6%' }
    }
  }

  const loginStyle = () => {
    return ( screenWidth <= 500 ) ? {
      backgroundColor: '#FFF', height: '60vh', px: 5, borderRadius: '40px', mt: '60%'
    } : {
      backgroundColor: '#FFF', height: '55vh', px: 5, borderRadius: '40px', mt: 34 
    };
  }

  return (
    <Grid container>
      {
        showDeleteModal &&
          <DangerModal view='errorLogin' />
      }
      <GridPrimaryDark item xs={12}>
        <img src={ require('../assets/img/logo.png') } style={ imgStyle() }></img>
        <h1 style={{ color: '#FFF', display: 'inline', marginLeft: '2rem' }}>HOTEL TECH</h1>
      </GridPrimaryDark>
      <GridPrimaryLight item xs={12}>

      </GridPrimaryLight>
      <Grid container sx={{ width: '100vw', height: '100vh', position: 'absolute', justifyContent: 'center', textAlign: 'center' }}>
        <Grid item xs={10} sm={7} md={4} sx={ loginStyle() }>
          <h3 style={{ fontFamily: 'Roboto-Thin', textAlign: 'center' }}>Admin Area</h3>

          <PrimaryLightInput
            sx={{ width: '100%', mb: 2 }}
            label="Username"
            value={username}
            onChange={ e => setUsername(e.target.value) }
          />
          <PrimaryLightInput
            sx={{ width: '100%' }}
            label="Password"
            value={password}
            onChange={ e => setPassword(e.target.value) }
            type={ showPassword ? 'text' : 'password' }
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  { showPassword ? 
                    <VisibilityOffIcon onClick={ () => handleVisibilityPassword() } />
                    : 
                    <VisibilityIcon onClick={ () => handleVisibilityPassword() } />
                  }
                </InputAdornment>
              ),
            }}
          />
          <Grid item xs={12} sx={{ textAlign: 'start', display: 'flex', alignItems: 'center' }}>
            <CheckboxPrimary label='holaa' />
            <p style={{ display: 'inline' }}>Mantenerme conectado</p>
          </Grid>
          
          <Grid item xs={12} sx={{ textAlign: 'start', mt: 4 }}>
            <PrimaryOutlinedButton sx={{ width: '40%' }} onClick={ () => loginAccess(username, password) }>Login</PrimaryOutlinedButton>
          </Grid>
          
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Login